import React, { ReactElement, useCallback, useState } from 'react';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import {
  Document,
  Page,
  StyleSheet,
  Text,
  PDFDownloadLink,
} from '@react-pdf/renderer';

export const FeedbackFormComponent = (values) => {
  const generateSchedule = useCallback(() => {}, [values]);

  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    });
  };

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
    },
    text: {
      marginTop: 42,
      fontSize: 12,
      textAlign: 'left',
    },
  });

  return (
    <>
      <PDFDownloadLink
        document={
          <>
            <Document>
              <Page style={styles.body}>
                <Text style={styles.title}>Questionairre / Feedback</Text>
                <Text style={styles.text}>
                  What is your opinion about the weekend? / Quelle est votre
                  opinion du weekend?
                </Text>
                <Text style={styles.text}>
                  Did you have any problems during your stay? Est-ce que vous
                  avez eu des problems pendant votre séjour?
                </Text>
                <Text style={styles.text}>
                  How did you like your guide, was she helpful and looking out
                  after you? Comment vous avez aimé votre guide?
                </Text>
                <Text style={styles.text}>
                  How would you rate your accommodation in terms of location,
                  comfortability and service? Comment évaluez vous votre
                  accomodation selon location, comfortabilité et service?
                </Text>
                <Text style={styles.text}>
                  Which activities did you like the best? Quel activité vous
                  avez préféré?
                </Text>
                <Text style={styles.text}>
                  If you have had the bar crawl activity, did you enjoy the
                  locations visited? Si vous avez eu le programme tour des bars,
                  est-ce que vous vous etes bien amusé aux bars, boites, clubs
                  visités?
                </Text>
                <Text style={styles.text}>
                  What would you change relating to the organization? Qu-est-ce
                  que vous voudriez changer dans l'organisation?
                </Text>
                <Text style={styles.text}>
                  What is your opinion about the prices in Budapest? Qu-est ce
                  que vous pensez des prix de Budapest?
                </Text>
                <Text style={styles.text}>
                  Which restaurants, bars, clubs did you like most, which of
                  these would you recommend to others? Quels restaurants,
                  boites, clubs, bars vous avez aimé le plus? Lesquels voudriez
                  vous recommander aux gens?
                </Text>
                <Text style={styles.text}>
                  Would you choose Budapest and Crazy Voyages again as a next
                  location / organizer for a future stag weekend? Voudriez-vous
                  choisir Budapest et Crazy EVG comme prochaine place /
                  organisateur de votre future EVG?
                </Text>
              </Page>
            </Document>
          </>
        }
        fileName="feedback.pdf"
        className={'mr-[5px]'}
      >
        <LoadingButton
          onClick={handleClick}
          loading={loading}
          variant="contained"
          disabled={loading}
        >
          Feedback Form
        </LoadingButton>
      </PDFDownloadLink>
    </>
  );
};
